/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  external_id,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/RemovePatient/Content"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let onClick = fromHelpers.useOnClick({
  children,
  external_id,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 right={0}
 onClick={onClick}
 skipCallingOnClickWhenMoreThanOneItemAndNoneSelected={true}
 height={80}
 data="options"
 from={optionsValueData}
/>
{children}
</React.Fragment>)
}